import { DrawerProps } from './types';

export const Drawer: React.FC<DrawerProps> = () => {
  // Drawer is not supported on native, yet.
  return null;
};
